module.exports = __webpack_public_path__ + "static/media/cases_3d_01a.b2c7a3d8.jpg";